module.exports = "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal-layer\" ng-style=\"{'z-index': 1050 + index*10}\" modal-in-class=\"open\" ng-click=\"close($event)\">\n    <div>\n        <div class=\"modal-container\" uib-modal-transclude></div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./project/modals/default/modal-container.html
// module id = 848
// module chunks = 3